var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import React from 'react';
import PropTypes from 'prop-types';

var Radio = function Radio(_ref) {
  var range = _ref.range,
      error = _ref.error,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange;

  return React.createElement(
    'div',
    { className: 'tg-radio form-group ' + className },
    range.map(function (option, index) {
      if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
        return React.createElement(
          'div',
          { key: index, className: 'form-input ' + className },
          React.createElement(
            'label',
            { htmlFor: name + option.value, className: 'label' },
            option.label
          ),
          React.createElement('input', {
            type: 'radio',
            className: 'select-field',
            defaultValue: option.value,
            checked: option.value == value,
            name: name,
            id: name + option.value,
            onChange: onChange
          })
        );
      }
      return React.createElement(
        'div',
        { key: index, className: 'form-input ' + className },
        React.createElement(
          'label',
          { htmlFor: name + option, className: 'label' },
          option
        ),
        React.createElement('input', {
          type: 'radio',
          className: 'select-field',
          defaultValue: option,
          checked: option == value,
          name: name,
          id: name + option,
          onChange: onChange
        })
      );
    }),
    React.createElement(
      'span',
      { className: 'error-message' },
      error
    )
  );
};

Radio.propTypes = {
  /** Array with objects containing a value and label */
  range: PropTypes.array,
  /** Optional className passed in as props */
  className: PropTypes.string,
  /** Validation errors */
  error: PropTypes.array,
  /** Name of the element */
  name: PropTypes.string,
  /** Value passed in as props */
  value: PropTypes.bool,
  /** Listens on changes */
  onChange: PropTypes.func
};

Radio.defaultProps = {
  range: [],
  className: '',
  error: [],
  name: '',
  value: false,
  onChange: null
};

export default Radio;